module.exports = "<div ui-view\n  ng-cloak>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/commande/templates/index.html
// module id = 1552
// module chunks = 0